import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=ffa302a4&scoped=true&"
import script from "./UploadFile.vue?vue&type=script&lang=js&"
export * from "./UploadFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=ffa302a4&lang=scss&scoped=true&"
import style1 from "./UploadFile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa302a4",
  null
  
)

export default component.exports